<template>
    <div class="wrapper">
        <div class="card card-custom">
            <div class="card-body p-0">
                <!--begin: Wizard-->
                <div class="wizard wizard-2" id="kt_wizard_v2" data-wizard-state="step-first"
                    data-wizard-clickable="true">
                    <!--begin: Wizard Nav -->
                    <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
                        <div class="wizard-steps">
                            <div class="wizard-step" data-wizard-type="step" data-wizard-state="current">
                                <div class="wizard-label">
                                    <i class="wizard-icon far fa-user-circle"></i>
                                    <div>
                                        <h3 class="wizard-title">1. PATIENT DETAILS</h3>
                                        <span class="text-muted">Office Visit Info</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-history"></i>
                                    <div>
                                        <h3 class="wizard-title">2. MEDICAL HISTORY</h3>
                                        <span class="text-muted">Subjective</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" href="#" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-th-list"></i>
                                    <div>
                                        <h3 class="wizard-title">3. REVIEW OF SYSTEM</h3>
                                        <span class="text-muted">Subjective</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-heartbeat"></i>
                                    <div>
                                        <h3 class="wizard-title">4. VITAL SIGNS</h3>
                                        <span class="text-muted">Objective</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon far fa-file-alt"></i>
                                    <div>
                                        <h3 class="wizard-title">5. ASSESSMENT</h3>
                                        <span class="text-muted">Objective-Assessment</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-box"></i>
                                    <div>
                                        <h3 class="wizard-title">6. PACKAGES</h3>
                                        <span class="text-muted">Treatments</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-tint"></i>
                                    <div>
                                        <h3 class="wizard-title">7. IV THERAPIES</h3>
                                        <span class="text-muted">IV serums</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-bong"></i>
                                    <div>
                                        <h3 class="wizard-title">8. LABORATORY</h3>
                                        <span class="text-muted">Treatment</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-eye-dropper"></i>
                                    <div>
                                        <h3 class="wizard-title">9. IH INTERVENTIONS</h3>
                                        <span class="text-muted">Treatment</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-crutch"></i>
                                    <div>
                                        <h3 class="wizard-title">10. IH TREATMENTS</h3>
                                        <span class="text-muted">Treatment</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon far fa-file-image"></i>
                                    <div>
                                        <h3 class="wizard-title">11. DIAGNOSTIC IMAGING</h3>
                                        <span class="text-muted">Treatment</span>
                                    </div>
                                </div>
                            </div>
                            <!-- Step 12: WEIGHT LOSS REFERRAL (optional) -->
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-weight"></i>
                                    <div>
                                        <h3 class="wizard-title">12. WEIGHT LOSS</h3>
                                        <span class="text-muted">Optional referral</span>
                                    </div>
                                </div>
                            </div>
                            <!-- Step 13: APPLY MEMBERSHIP (solo cuando membership_type === 1) -->
                            <div v-if="showApplyMembershipStep" class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-id-card"></i>
                                    <div>
                                        <h3 class="wizard-title">13. APPLY MEMBERSHIP</h3>
                                        <span class="text-muted">Discounts</span>
                                    </div>
                                </div>
                            </div>
                            <div class="wizard-step" data-wizard-type="step">
                                <div class="wizard-label">
                                    <i class="wizard-icon fas fa-dollar-sign"></i>
                                    <div>
                                        <h3 class="wizard-title">{{ showApplyMembershipStep ? '14' : '13' }}. CHARGES AND COSTS</h3>
                                        <span class="text-muted">Billing</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end: Wizard Nav -->

                    <!--begin: Wizard Body -->
                    <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
                        <!--begin: Wizard Form-->
                        <div class="row">
                            <div class="col-xxl-12">
                                <form class="form" id="kt_form" ref="formNurse">
                                    <!--begin: Wizard Step 1-->
                                    <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
                                        <validation-observer tag="form">
                                            <PatientDetails :detailPatient="detailPatient" :roomOptions="roomOptions" />
                                        </validation-observer>
                                    </div>
                                    <!--end: Wizard Step 1-->

                                    <!--begin: Wizard Step 2-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <MedicalHistory v-if="medicalHistoryConditional"
                                            :medicalHistory="medicalHistory" :allergiesOptions="allergiesOptions"
                                            :ailmentOptions="ailmentOptions" :medicationsOptions="medicationsOptions"
                                            :medicationsPatientOptions="medicationsPatientOptions" />
                                    </div>
                                    <!--end: Wizard Step 2-->

                                    <!--begin: Wizard Step 3-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <ReviewSystem :reviewSystemSelected="reviewSystemSelected"
                                            :reviewSystemLength="reviewSystemLength" />
                                    </div>
                                    <!--end: Wizard Step 3-->

                                    <!--begin: Wizard Step 4-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <VitalSign :vitalSign="vitalSign" :signVitalsOptions="signVitalsOptions" />
                                    </div>
                                    <!--end: Wizard Step 4-->

                                    <!--begin: Wizard Step 5-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <AssessmentProcedure v-if="medicalHistoryConditional"
                                            :medicalHistory="medicalHistory" :assessmentProcedure="assessmentProcedure"
                                            :ailmentOptions="ailmentOptions" :diagnosesOptions="diagnosesOptions" />
                                    </div>
                                    <!--end: Wizard Step 5 -->

                                    <!--begin: Wizard Step 6-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <PackageProcedure v-if="medicalHistoryConditional" :package="package"
                                            :laboratories="laboratories" :interventions="interventions"
                                            :treatments="treatments" :tests="tests" :diagnostics="diagnostics"
                                            :optionsPackage="optionsPackage" @pricePackage="pricePackage($event)" />
                                    </div>
                                    <!--end: Wizard Step 6 -->

                                    <!--begin: Wizard Step 7 - IV therapies -->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <IvTherapiesProcedure
                                            :initial-serums="initialIvSerums"
                                            :facility-id="detailPatient.facilityId"
                                            :visit-date="detailPatient.visitDate"
                                            @change="onIvChange" />
                                    </div>
                                    <!--end: Wizard Step 7 -->

                                    <!--begin: Wizard Step 7-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <LaboratoryProcedure :laboratoryPromotion="laboratoryPromotion"
                                            :laboratorySelected="laboratorySelected"
                                            :laboratoryLength="laboratoryLength" :procedurePacks="procedurePacks"
                                            :totalPriceLaboratory="totalPriceLaboratory"
                                            :totalPriceDiagnosticImaging="totalPriceDiagnosticImaging"
                                            :totalPriceInterventions="totalPriceInterventions"
                                            :totalPriceTreatment="totalPriceTreatment" />
                                    </div>
                                    <!--end: Wizard Step 7 -->

                                    <!--begin: Wizard Step 8-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <InterventionsProcedure v-if="medicalHistoryConditional"
                                            :interventionsProcedure="interventionsProcedure" :testOptions="testOptions"
                                            :procedureOptions="procedureOptions"
                                            :totalPriceInterventions="totalPriceInterventions"
                                            :totalPriceLaboratory="totalPriceLaboratory"
                                            :totalPriceDiagnosticImaging="totalPriceDiagnosticImaging"
                                            :totalPriceTreatment="totalPriceTreatment" />
                                    </div>
                                    <!--end: Wizard Step 8 -->

                                    <!--begin: Wizard Step 9-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <TreatmentProcedure v-if="treatmentProcedure.length > 0"
                                            :treatmentProcedure="treatmentProcedure"
                                            :treatmentOptions="treatmentOptions"
                                            :totalPriceTreatment="totalPriceTreatment"
                                            :totalPriceInterventions="totalPriceInterventions"
                                            :totalPriceLaboratory="totalPriceLaboratory"
                                            :totalPriceDiagnosticImaging="totalPriceDiagnosticImaging" />
                                    </div>
                                    <!--end: Wizard Step 9 -->

                                    <!--begin: Wizard Step 10-->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <ImagingProcedure :diagnosticPromotion="diagnosticPromotion"
                                            :diagnosticSelected="diagnosticSelected"
                                            :diagnosticLength="diagnosticLength"
                                            :totalPriceDiagnosticImaging="totalPriceDiagnosticImaging"
                                            :totalPriceTreatment="totalPriceTreatment"
                                            :totalPriceInterventions="totalPriceInterventions"
                                            :totalPriceLaboratory="totalPriceLaboratory" />
                                    </div>
                                    <!--end: Wizard Step 10 -->

                                    <!--begin: Wizard Step 11 - Weight loss referral (optional) -->
                                    <div class="pb-5" data-wizard-type="step-content">
                                        <WeightlossReferralStep
                                            :enabled="weightlossReferralEnabled"
                                            :form="weightlossReferral"
                                            :mode="weightlossMode"
                                            :balances="weightlossBalances"
                                            :balances-loading="weightlossBalancesLoading"
                                            :balances-error="weightlossBalancesError"
                                            :lock-enabled="hadWeightlossOnLoad"
                                            :facility-id="detailPatient.facilityId"
                                            :quote-visit-date="detailPatient.visitDate"
                                            :weightloss-patient-id="detailPatient.weightlossPatientId"
                                            @enabled="onWeightlossEnabled"
                                            @change="onWeightlossChange"
                                            @pricing="onWeightlossPricing" />
                                    </div>
                                    <!--end: Wizard Step 11-->

                                    <!--begin: Wizard Step 12 - Apply membership (solo cuando membership_type === 1) -->
                                    <div v-if="showApplyMembershipStep" class="pb-5" data-wizard-type="step-content">
                                        <MembershipApplyStep
                                            :membership="membership"
                                            :apply-membership="applyMembership"
                                            @applyMembership="onApplyMembership" />
                                    </div>
                                    <!--end: Wizard Step 12-->

                                    <!--begin: Wizard Step 12/13 - Charges and costs -->
                                    <div class="pb-5 fin" data-wizard-type="step-content">
                                        <CostProcedure ref="cost"
                                            :totalPriceDiagnosticImaging="totalPriceDiagnosticImaging"
                                            :treatmentProcedure="treatmentProcedure"
                                            :totalPriceLaboratory="totalPriceLaboratory"
                                            :totalPriceInterventions="totalPriceInterventions"
                                            :membership="membershipForCost"
                                            :totalPriceTreatment="totalPriceTreatment" :getCostProcedure="costProcedure"
                                            :totalPricePackage="totalPricePackage" :detailsPatient="detailPatient"
                                            :laboratorySelected="laboratorySelected" :procedurePacks="procedurePacks"
                                            :interventionsProcedure="interventionsProcedure"
                                            :consultation="consultationPrice" :diagnosticSelected="diagnosticSelected"
                                            :campaign_cupon="detailPatient.campaign_cupon"
                                            :totalPriceWeightloss="totalPriceWeightlossForCost"
                                            :weightlossLabel="weightlossCostLabel"
                                            :totalPriceIvAddons="totalPriceIvAddons"
                                            :totalPriceIvSerums="totalPriceIvSerums"
                                            @totalAdjustment="totalAdjustment" @is_cupon="getCupon"
                                            @totalPrice="totalPrice" @noKen="noKen">
                                            <div v-if="costProcedure.signature != null">
                                                <img :src="costProcedure.signature" alt="" />
                                            </div>
                                            <div v-else>
                                                <b-form-group label="Signature" label-for="signature">
                                                    <div class="d-flex">
                                                        <VueSignaturePad id="signature" width="100%" height="20vh"
                                                            ref="signaturePad" class="border border-primary rounded"
                                                            :options="{
                                                onBegin: () => {
                                                    $refs.signaturePad.resizeCanvas();
                                                },
                                            }" />
                                                        <div class="align-self-center">
                                                            <b-button
                                                                class="btn-icon align-self-center mx-1 cursor-pointer"
                                                                variant="danger" @click="clearSignature">
                                                                <i class="far fa-trash-alt"></i>
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                            </div>
                                        </CostProcedure>
                                    </div>
                                    <!--end: Wizard Step 11/12 -->

                                    <!--begin: Wizard Actions -->
                                    <div class="d-flex justify-content-between border-top pt-10">
                                        <div class="mr-2">
                                            <button
                                                class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-prev">
                                                Previous
                                            </button>
                                        </div>
                                        <div>
                                            <button v-on:click="submit"
                                                class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-submit" :disabled="sbmLoading">
                                                Submit
                                            </button>
                                            <button class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-next">
                                                Next Step
                                            </button>
                                        </div>
                                    </div>
                                    <!--end: Wizard Actions -->
                                </form>
                            </div>
                            <!--end: Wizard-->
                        </div>
                    </div>
                    <!--end: Wizard Body -->
                </div>
                <ToastNotification ref="toast" />
                <!--end: Wizard-->
                <!-- <checkConsent :dataTreatment="dataTreatment" @closeModalConset="closeConcent($event)" @checkConsent="checkCont($event)"/> -->
            </div>
        </div>
        <panelSteps :totalPriceLaboratory="totalPriceLaboratory"
            :totalPriceDiagnosticImaging="totalPriceDiagnosticImaging"
            :totalPriceInterventions="totalPriceInterventions" :totalPriceTreatment="totalPriceTreatment"
            :totalPricePackage="totalPricePackage" :consultation="consultationPrice"
            :laboratorySelected="laboratorySelected" :membership="membership"
            :interventionsProcedure="interventionsProcedure" :treatmentProcedure="treatmentProcedure"
            :treatmentOptions="treatmentOptions" :diagnosticSelected="diagnosticSelected" :package="package"
            :campaign_cupon="detailPatient.campaign_cupon"
            :totalPriceWeightloss="totalPriceWeightlossForCost"
            :weightlossLabel="weightlossCostLabel"
            :totalPriceIvAddons="totalPriceIvAddons"
            :totalPriceIvSerums="totalPriceIvSerums"
            :ivPricing="ivPricing"
            class="card2" />
    </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";

@media screen and (min-width: 1250px) {
    .card {
        grid-column: 1 / 6;
        grid-row: 1;
    }

    .card2 {
        grid-column: 6 / 6;
        grid-row: 1;
    }

    .wrapper {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: 10px;
        grid-auto-rows: minmax(100px, auto);
    }
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import { ValidationObserver } from "vee-validate";
import ToastNotification from "@/components/ToastNotification";
import checkConsent from "../recipe/checkConsent.vue";
import PatientDetails from "./components/PatientDetails";
import MedicalHistory from "./components/MedicalHistory";
import ReviewSystem from "./components/ReviewSystem";
import VitalSign from "./components/VitalSign";
import AssessmentProcedure from "./components/AssessmentProcedure";
import PackageProcedure from "./components/PackageProcedure";
import LaboratoryProcedure from "./components/LaboratoryProcedure";
import InterventionsProcedure from "./components/InterventionsProcedure";
import TreatmentProcedure from "./components/TreatmentProcedure";
import ImagingProcedure from "./components/ImagingProcedure";
import MembershipApplyStep from "./components/MembershipApplyStep";
import WeightlossReferralStep from "./components/WeightlossReferralStep";
import IvTherapiesProcedure from "./components/IvTherapiesProcedure";
import CostProcedure from "./components/CostProcedure";
import panelSteps from "./components/panelSteps"

import axiosOV from "@/core/services/api/office-visit";
import axiosEC from "@/core/services/api/external-settings/cloudinary";
import axiosPA from "@/core/services/api/patient";
import axiosAI from "@/core/services/api/admin/consults/packages";
import { toProjectDateTime } from "@/core/services/api/weightloss-inventory/dateFormat";
import { isIvTherapyPackage } from "@/core/utils/ivTherapies";

export default {
    name: "Wizard-2",
    components: {
        ValidationObserver,
        ToastNotification,
        // checkConsent,
        PatientDetails,
        MedicalHistory,
        ReviewSystem,
        VitalSign,
        AssessmentProcedure,
        PackageProcedure,
        LaboratoryProcedure,
        InterventionsProcedure,
        TreatmentProcedure,
        ImagingProcedure,
        MembershipApplyStep,
        WeightlossReferralStep,
        IvTherapiesProcedure,
        CostProcedure,
        panelSteps
    },
    computed: {
        /** true cuando membership_type === 1: se muestra paso Apply membership */
        showApplyMembershipStep() {
            const m = this.membership
            if (!m || !m.memberships_parameters) return false
            return Number(m.memberships_parameters.membership_type) === 1
        },
        /** Membership a pasar a CostProcedure: si tipo 1 depende del toggle; si tipo 0 siempre membership */
        membershipForCost() {
            if (this.showApplyMembershipStep) {
                return this.applyMembership && this.membership && this.membership.id ? this.membership : null
            }
            return this.membership
        },
        totalPriceWeightlossForCost() {
            if (!this.weightlossReferralEnabled) return 0
            if (this.weightlossMode === 'consume') return 0
            const price = Number(this.totalPriceWeightloss)
            return Number.isFinite(price) ? price : 0
        },
        weightlossCostLabel() {
            if (!this.weightlossReferralEnabled) return ''
            if (this.weightlossMode === 'consume') {
                return this.weightlossTreatmentLabel || 'Weight loss (pending dose)'
            }
            return this.weightlossTreatmentLabel || 'Weight loss'
        },
        isPendingInjection() {
            return this.normalizeTypeVisitId(this.detailPatient.type_visits_id) === 4
        },
        totalPriceLaboratory() {
            let total = 0;
            const laboratorySelected = this.laboratorySelected;
            for (const key in laboratorySelected) {
                laboratorySelected[key].forEach(
                    (item) => (total += parseInt(item.price))
                );
            }
            const laboratoryPackSelected = this.procedurePacks.laboratoriesPack;
            for (const key of laboratoryPackSelected) {
                total += parseInt(key.price);
            }
            return total;
        },
        totalPriceInterventions() {
            let total = 0;
            const { procedures, tests } = this.interventionsProcedure;
            const totalInterventions = procedures.concat(tests);
            for (const key of totalInterventions) {
                total += parseInt(key.price);
            }
            return total;
        },
        totalPriceTreatment() {
            let total = 0;
            const treatmentProcedure = this.treatmentProcedure;
            for (const key of treatmentProcedure) {
                key.cant && (total += parseInt(key.price) * key.cant);
            }
            return total;
        },
        totalPriceDiagnosticImaging() {
            let total = 0;
            const diagnosticSelected = this.diagnosticSelected;
            for (const key in diagnosticSelected) {
                diagnosticSelected[key].forEach((item) => {
                    return (total += parseInt(item.price));
                });
            }
            return total;
        },
    },
    watch: {
        /** Cuando no se aplica membresía (tipo 1), resetear adjustment para que el total = subtotal */
        applyMembership(val) {
            if (!val && this.showApplyMembershipStep) {
                this.costProcedure.adjusment = 0;
            }
        },
    },
    data() {
        return {
            package: {
                data: null
            },
            optionsPackage: [],
            detailPatient: {
                type_visits_id: 0,
                gender: '',
                name: "",
                lastName: "",
                phone: "",
                dateBirth: null,
                facility: null,
                facilityId: null,
                visitDate: null,
                weightlossPatientId: null,
                room: [],
            },
            medicalHistory: {
                ailments: [],
                allergies: [],
                medicationInformation: [],
                current_medications: false,
                userId: null,
                historyId: null,
            },
            vitalSign: [],
            ailmentOptions: {
                data: null,
            },
            allergiesOptions: {
                data: null,
            },
            medicationsOptions: {
                data: null,
            },
            reviewSystemLength: {
                data: null,
            },
            diagnosesOptions: {
                data: null,
            },
            testOptions: {
                data: null,
            },
            procedureOptions: {
                data: null,
            },
            treatmentProcedure: [],
            assessmentProcedure: {
                examination: null,
                describeAbnormal: null,
                describeDiagnoses: null,
                diagnosis: [],
            },
            laboratoryLength: {
                data: null,
            },
            diagnosticLength: {
                data: null,
            },
            medicationsPatientOptions: {
                data: null,
            },
            reviewSystemSelected: {},
            laboratorySelected: {},
            membership: {},
            /** Solo usado cuando membership_type === 1: si se aplican descuentos de membresía */
            applyMembership: true,
            diagnosticSelected: {},
            laboratoryPromotion: [],
            diagnosticPromotion: [],
            interventionsProcedure: {
                tests: [],
                procedures: [],
            },
            procedurePacks: {
                laboratoriesPack: [],
                checkCategoryLaboratory: {},
            },
            roomOptions: [],
            signVitalsOptions: [],
            treatmentOptions: [],
            loading: false,
            sbmLoading: false,
            conditionalSignature: false,
            totalPriceProcedure: 0,
            costProcedure: {
                signature: null,
                adjusment: 0,
                authorization: false,
                is_cupon: false
            },
            consultationPrice: {},
            medicalHistoryConditional: false,
            wizardForm: null,
            totalPricePackage: 0,
            diagnosesAs: [],
            endWiz: false,
            laboratories: [],
            interventions: [],
            treatments: [],
            diagnostics: [],
            tests: [],
            weightlossReferralEnabled: false,
            weightlossMode: 'sell',
            weightlossBalances: [],
            weightlossBalancesLoading: false,
            weightlossBalancesError: '',
            hadWeightlossOnLoad: false,
            weightlossConsumeBlockedMessage: '',
            weightlossReferral: {
                mode: 'sell',
                weightloss_treatment_id: null,
                weightloss_dose_id: null,
                weightloss_dose_balance_id: null,
                qty_doses: 1,
                addons: [],
                goal_weight: '',
                visit_date: '',
                note: '',
            },
            totalPriceWeightloss: null,
            initialIvSerums: [],
            ivSerums: [],
            ivPricing: null,
            totalPriceIvSerums: 0,
            totalPriceIvAddons: 0,
            ivQuoteError: '',
            ivQuoteLoading: false,
            ivInvalidMessage: '',
            weightlossTreatmentLabel: '',
            weightlossPricing: null,
            weightlossQuoteError: '',
            weightlossQuoteLoading: false,
        };
    },
    created() {
        axiosAI.getList().then(({ laboratories, diagnostic_imagings, procedures, treatments, tests }) => {
            this.laboratories = laboratories
            this.diagnostics = diagnostic_imagings
            this.interventions = procedures
            this.treatments = treatments
            this.tests = tests
        })
        axiosAI.getPackages(20).then(({ data: { data } }) => {
            this.package.all = data;
        })
    },
    mounted() {
        this.getDetails();
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Office Visit", route: "../table" },
            { title: "Nurse" },
        ]);
    },
    methods: {
        submit: async function (e) {
            e.preventDefault();

            if (!this.validateWeightlossReferral()) {
                this.sbmLoading = false
                return
            }
            if (!this.validateIvSerums()) {
                this.sbmLoading = false
                return
            }

            const checkPhoto = await this.handlePhoto();
            this.sbmLoading = true
            if (checkPhoto) {
                try {
                    const dataOma = await this.createDataOma();
                    await this.checkRoomAvailability(dataOma.room);

                    const { registro } = await this.updatePatientDetails();
                    await this.updateReasonVisit(registro);

                    await this.completeOmaProcedure(dataOma);

                    this.$refs.toast.success("The OMA procedure was completed");
                    this.endWiz = false;
                    this.sbmLoading = false
                    this.$router.go(-1);
                } catch (error) {
                    this.sbmLoading = false
                    this.handleError(error);
                }
            }
            this.sbmLoading = false
        },
        async handlePhoto() {
            if (this.costProcedure.signature) {
                return true;
            } else {
                const savePhoto = this.isSignature();
                if (savePhoto) {
                    const { data } = this.$refs.signaturePad.saveSignature();
                    const photoUrl = await this.uploadPhoto(data);
                    this.costProcedure.signature = photoUrl;
                    return true;
                } else {
                    this.$refs.toast.danger("Signature required");
                    return false;
                }
            }
        },
        async createDataOma() {
            const {
                room,
                finallyReviewSystem,
                finallyLaboratory,
                laboratoriesPack,
                finallyDiagnosticImagings,
                finallyProcedures,
                finallyTest,
                filterTreatment,
                examination,
                describeAbnormal,
                describeDiagnoses,
                diagnosis,
            } = this.createDataObjects();

            const dataOma = {
                room,
                vital_signs: this.vitalSign,
                review_of_system: finallyReviewSystem,
                laboratories: finallyLaboratory,
                laboratories_pack: this.createFinalArray(laboratoriesPack),
                diagnostic_imagings: finallyDiagnosticImagings,
                procedures: finallyProcedures,
                tests: finallyTest,
                examination,
                describe_abnormal: describeAbnormal,
                describe_diagnoses: describeDiagnoses,
                diagnosis,
                treatments: filterTreatment,
                history: { ...this.medicalHistory },
                signature: this.costProcedure.signature,
                total: Number(this.totalPriceProcedure),
                ajustment: this.costProcedure.adjusment,
                is_cupon: this.costProcedure.is_cupon,
                authorization: this.costProcedure.authorization,
                package_id: this.package.data != null ? this.package.data : null,
            };
            if (this.weightlossReferralEnabled) {
                dataOma.weightloss = this.buildWeightlossPayload()
            }
            if (this.ivSerums.length) {
                dataOma.iv = { serums: this.ivSerums }
            }
            return dataOma
        },
        getCupon(isCupon) {
            this.costProcedure.is_cupon = isCupon
        },
        async checkRoomAvailability(room) {
            const res = await axiosOV.roomsCheckAvailable(this.$route.params.id, typeof room != 'number' ? room[0] : room);
            if (res.status === 'ERROR') {
                throw new Error(res.message);
            }
        },
        async updatePatientDetails() {
            const { registro } = await axiosPA.patientDetail(this.medicalHistory.userId);
            registro.gender = this.detailPatient.gender;
            return axiosPA.patientUpdate(this.medicalHistory.userId, registro);
        },
        async updateReasonVisit(registro) {
            const resp = await axiosOV.updateReasonVisit(this.detailPatient.appointmentsId, { reason_visit: this.detailPatient.reason_visit });
            if (resp.status !== 'OK') {
                throw new Error("Check the gender of the patient");
            }
        },
        async completeOmaProcedure(dataOma) {
            const data = await axiosOV.procedureOma(this.$route.params.id, dataOma);
            if (!data || String(data.status || '').toLowerCase() === 'error') {
                const err = new Error(data?.message || "The OMA procedure could not be completed.");
                err.validation = String(data?.type || '').toLowerCase() === 'validation';
                err.responseData = data;
                throw err;
            }
        },
        validateWeightlossReferral() {
            if (this.hadWeightlossOnLoad && !this.weightlossReferralEnabled) {
                this.$refs.toast.danger(
                    "Esta visita ya tiene un registro de weightloss. Los cambios deben gestionarse con un administrador."
                )
                return false
            }
            if (this.weightlossConsumeBlockedMessage && this.hadWeightlossOnLoad) {
                this.$refs.toast.danger(this.weightlossConsumeBlockedMessage)
                return false
            }
            if (!this.weightlossReferralEnabled) return true

            if (this.weightlossMode === 'consume') {
                const balanceId = this.weightlossReferral.weightloss_dose_balance_id
                if (balanceId == null || balanceId === '') {
                    this.$refs.toast.danger("Select a pending dose balance to apply.")
                    return false
                }
                return true
            }

            const {
                weightloss_treatment_id,
                weightloss_dose_id,
                qty_doses,
                visit_date,
            } = this.weightlossReferral
            if (!weightloss_treatment_id) {
                this.$refs.toast.danger("Weight loss treatment is required.")
                return false
            }
            if (!weightloss_dose_id) {
                this.$refs.toast.danger("Weight loss dose is required.")
                return false
            }
            if (!Number.isInteger(Number(qty_doses)) || Number(qty_doses) < 1 || Number(qty_doses) > 4) {
                this.$refs.toast.danger("Weight loss quantity must be between 1 and 4 doses.")
                return false
            }
            if (!visit_date || !String(visit_date).trim()) {
                this.$refs.toast.danger("Weight loss follow-up date and time are required (MM-DD-YYYY HH:mm:ss).")
                return false
            }
            if (!toProjectDateTime(visit_date)) {
                this.$refs.toast.danger("Invalid weight loss follow-up date. Use MM-DD-YYYY HH:mm:ss.")
                return false
            }
            if (this.weightlossQuoteLoading) {
                this.$refs.toast.warning("Wait for the weight loss price calculation to finish.")
                return false
            }
            if (this.weightlossQuoteError) {
                this.$refs.toast.danger(this.weightlossQuoteError)
                return false
            }
            if (!this.weightlossPricing || this.totalPriceWeightloss == null) {
                this.$refs.toast.danger("A valid weight loss pricing quote is required.")
                return false
            }
            return true
        },
        buildWeightlossPayload() {
            if (this.weightlossMode === 'consume') {
                const payload = {
                    mode: 'consume',
                    weightloss_dose_balance_id: Number(this.weightlossReferral.weightloss_dose_balance_id),
                }
                const note = (this.weightlossReferral.note || '').trim()
                if (note) payload.note = note
                return payload
            }

            const visitDate = toProjectDateTime(this.weightlossReferral.visit_date)
            if (!visitDate) {
                throw new Error("Weight loss visit date and time are required (MM-DD-YYYY HH:mm:ss).")
            }
            const payload = {
                mode: 'sell',
                weightloss_treatment_id: Number(this.weightlossReferral.weightloss_treatment_id),
                weightloss_dose_id: Number(this.weightlossReferral.weightloss_dose_id),
                qty_doses: Number(this.weightlossReferral.qty_doses),
                visit_date: visitDate,
            }
            const addons = (this.weightlossReferral.addons || [])
                .filter(addon => addon.weightloss_addon_id)
                .map(addon => ({
                    weightloss_addon_id: Number(addon.weightloss_addon_id),
                    qty: Number(addon.qty) || 1,
                }))
            if (addons.length) payload.addons = addons
            const goal = this.weightlossReferral.goal_weight
            if (goal !== '' && goal != null) {
                payload.goal_weight = Number(goal)
            }
            const note = (this.weightlossReferral.note || '').trim()
            if (note) payload.note = note
            return payload
        },
        onWeightlossEnabled(value) {
            if (this.hadWeightlossOnLoad && !value) {
                this.weightlossReferralEnabled = true
                this.$refs.toast?.warning?.(
                    "Esta visita ya tiene weightloss; no se puede quitar desde el flujo. Contacte a un administrador."
                )
                return
            }
            this.weightlossReferralEnabled = !!value
            if (!value) {
                this.totalPriceWeightloss = null
                this.weightlossTreatmentLabel = ''
                this.weightlossPricing = null
                this.weightlossQuoteError = ''
                this.weightlossQuoteLoading = false
            } else if (this.weightlossMode === 'consume') {
                this.totalPriceWeightloss = 0
                this.weightlossPricing = { total: 0 }
                this.weightlossQuoteError = ''
                this.weightlossQuoteLoading = false
            }
        },
        onWeightlossChange(form) {
            this.weightlossReferral = {
                ...this.weightlossReferral,
                ...form,
                mode: this.weightlossMode,
            }
            if (this.weightlossMode === 'consume' && form.weightloss_dose_balance_id != null) {
                const selected = (this.weightlossBalances || []).find(
                    b => Number(b.weightloss_dose_balance_id) === Number(form.weightloss_dose_balance_id)
                )
                if (selected) {
                    this.weightlossTreatmentLabel =
                        `${selected.treatment_name || 'Weight loss'} — ${selected.dose_label || ''}`.trim()
                }
            }
        },
        onWeightlossPricing({ pricing, total, error, loading, treatmentLabel }) {
            if (this.weightlossMode === 'consume') {
                this.weightlossPricing = { total: 0 }
                this.totalPriceWeightloss = 0
                this.weightlossQuoteError = ''
                this.weightlossQuoteLoading = false
                if (treatmentLabel) this.weightlossTreatmentLabel = treatmentLabel
                return
            }
            this.weightlossPricing = pricing
            this.totalPriceWeightloss = total
            this.weightlossQuoteError = error || ''
            this.weightlossQuoteLoading = !!loading
            this.weightlossTreatmentLabel = treatmentLabel || 'Weight loss'
        },
        handleError(error) {
            console.error(error);
            if (error?.validation || String(error?.responseData?.type || '').toLowerCase() === 'validation') {
                this.$refs.toast.danger(error.message);
                return
            }
            const msg = error?.message || 'The OMA procedure could not be completed.'
            this.$refs.toast.danger(msg);
        },
        normalizeTypeVisitId(value) {
            return Number(value?.id ?? value) || 0
        },
        findWeightlossVisitCandidate(officeVisit) {
            const appointment = officeVisit?.appointments || {}
            const candidates = [
                officeVisit?.weightloss_visit,
                officeVisit?.weightlossVisit,
                officeVisit?.weightloss,
                officeVisit?.weightloss?.visit,
                appointment?.weightloss_visit,
                appointment?.weightlossVisit,
            ].filter(Boolean)
            return candidates.find(item =>
                item.mode === 'consume' ||
                item.mode === 'sell' ||
                item.weightloss_dose_balance_id ||
                item.weightloss_dose_id ||
                item.dose?.id ||
                item.qty_doses
            ) || null
        },
        extractBalanceIdFromVisit(visit, officeVisit) {
            return (
                visit?.weightloss_dose_balance_id ||
                visit?.dose_balance_id ||
                visit?.balance?.id ||
                visit?.weightloss_dose_balance?.id ||
                officeVisit?.weightloss_dose_balance_id ||
                officeVisit?.weightloss?.weightloss_dose_balance_id ||
                null
            )
        },
        resolveConsumeBalanceId(visit, officeVisit) {
            const fromVisit = this.extractBalanceIdFromVisit(visit, officeVisit)
            if (fromVisit != null && fromVisit !== '') return Number(fromVisit)

            const doseId = visit?.weightloss_dose_id || visit?.dose?.id || null
            if (doseId != null) {
                const match = (this.weightlossBalances || []).find(
                    b => Number(b.weightloss_dose_id) === Number(doseId)
                )
                if (match) return Number(match.weightloss_dose_balance_id)
            }

            if ((this.weightlossBalances || []).length === 1) {
                return Number(this.weightlossBalances[0].weightloss_dose_balance_id)
            }
            return null
        },
        async loadWeightlossBalances(officeVisitId) {
            this.weightlossBalancesLoading = true
            this.weightlossBalancesError = ''
            try {
                const res = await axiosOV.weightlossBalances(officeVisitId)
                if (!res || String(res.status || '').toLowerCase() === 'error') {
                    this.weightlossBalances = []
                    this.weightlossBalancesError =
                        res?.message || 'Could not load pending dose balances.'
                    return
                }
                this.weightlossBalances = Array.isArray(res.data) ? res.data : []
            } catch (error) {
                this.weightlossBalances = []
                this.weightlossBalancesError =
                    error?.message || 'Could not load pending dose balances.'
            } finally {
                this.weightlossBalancesLoading = false
            }
        },
        applyConsumeZeroPricing(label) {
            this.totalPriceWeightloss = 0
            this.weightlossPricing = { total: 0 }
            this.weightlossQuoteError = ''
            this.weightlossQuoteLoading = false
            if (label) this.weightlossTreatmentLabel = label
        },
        hydrateWeightlossSell(visit, officeVisit) {
            const appointment = officeVisit?.appointments || {}
            const followup =
                visit.weightloss_appointment ||
                visit.appointment ||
                officeVisit?.weightloss_appointment ||
                appointment?.weightloss_appointment ||
                {}
            const profile =
                visit.weightloss_patient ||
                followup.weightloss_patient ||
                officeVisit?.weightloss_patient ||
                {}

            this.weightlossReferralEnabled = true
            this.weightlossReferral = {
                mode: 'sell',
                weightloss_treatment_id:
                    visit.weightloss_treatment_id ||
                    visit.treatment?.id ||
                    profile.weightloss_treatment_id ||
                    null,
                weightloss_dose_id:
                    visit.weightloss_dose_id ||
                    visit.dose?.id ||
                    null,
                weightloss_dose_balance_id: null,
                qty_doses: Number(visit.qty_doses) || 1,
                addons: (visit.addons || []).map(item => ({
                    weightloss_addon_id:
                        item.weightloss_addon_id ||
                        item.addon?.id ||
                        item.pivot?.weightloss_addon_id ||
                        null,
                    qty: Number(item.qty || item.pivot?.qty) || 1,
                })),
                goal_weight:
                    profile.goal_weight ??
                    followup.weightloss_patient?.goal_weight ??
                    '',
                visit_date: followup.visit_date || '',
                note: followup.note || visit.note || visit.notes || '',
            }
            if (profile.id) this.detailPatient.weightlossPatientId = profile.id
        },
        hydrateWeightlossConsume(visit, officeVisit) {
            const note = visit?.note || visit?.notes || officeVisit?.weightloss?.note || ''
            const balanceId = this.resolveConsumeBalanceId(visit, officeVisit)

            this.weightlossReferral = {
                mode: 'consume',
                weightloss_treatment_id: null,
                weightloss_dose_id: null,
                weightloss_dose_balance_id: balanceId,
                qty_doses: 1,
                addons: [],
                goal_weight: '',
                visit_date: '',
                note: note || '',
            }

            const selected = balanceId != null
                ? (this.weightlossBalances || []).find(
                    b => Number(b.weightloss_dose_balance_id) === Number(balanceId)
                )
                : null

            if (selected) {
                this.applyConsumeZeroPricing(
                    `${selected.treatment_name || 'Weight loss'} — ${selected.dose_label || ''}`.trim()
                )
                this.weightlossReferralEnabled = true
                this.weightlossConsumeBlockedMessage = ''
                return
            }

            // Reenvío de consumo ya guardado: el saldo puede no aparecer en balances (agotado).
            if (this.hadWeightlossOnLoad && balanceId != null) {
                this.applyConsumeZeroPricing('Weight loss (pending dose)')
                this.weightlossReferralEnabled = true
                this.weightlossConsumeBlockedMessage = ''
                return
            }

            if (this.hadWeightlossOnLoad && balanceId == null) {
                this.weightlossReferralEnabled = false
                this.weightlossConsumeBlockedMessage =
                    'Esta visita ya consumió saldo; correcciones con administrador.'
                this.applyConsumeZeroPricing('')
                return
            }

            // Primera vez en P/I: hay saldos → permitir; sin saldos → deshabilitar.
            if ((this.weightlossBalances || []).length > 0) {
                this.weightlossReferralEnabled = false
                this.applyConsumeZeroPricing('Weight loss (pending dose)')
            } else {
                this.weightlossReferralEnabled = false
                this.applyConsumeZeroPricing('')
            }
            this.weightlossConsumeBlockedMessage = ''
        },
        async hydrateWeightlossFromOfficeVisit(officeVisit) {
            const visit = this.findWeightlossVisitCandidate(officeVisit)
            this.hadWeightlossOnLoad = !!visit
            this.weightlossConsumeBlockedMessage = ''

            if (this.weightlossMode === 'consume') {
                this.hydrateWeightlossConsume(visit || {}, officeVisit)
                return
            }

            this.weightlossMode = 'sell'
            if (!visit) return
            this.hydrateWeightlossSell(visit, officeVisit)
        },
        createDataObjects() {
            return {
                room: this.detailPatient.room,
                finallyReviewSystem: this.createFinalCategories(this.reviewSystemSelected),
                finallyLaboratory: this.createFinalCategories(this.laboratorySelected, true),
                laboratoriesPack: this.procedurePacks.laboratoriesPack,
                finallyDiagnosticImagings: this.createFinalCategories(this.diagnosticSelected, true),
                finallyProcedures: this.createFinalArray(this.interventionsProcedure.procedures),
                finallyTest: this.createFinalArray(this.interventionsProcedure.tests),
                filterTreatment: this.treatmentProcedure.filter(item => item.cant != null),
                examination: this.assessmentProcedure.examination,
                describeAbnormal: this.assessmentProcedure.describeAbnormal,
                describeDiagnoses: this.assessmentProcedure.describeDiagnoses,
                diagnosis: this.assessmentProcedure.diagnosis,
            };
        },
        createFinalCategories(selected, includeTrue = false) {
            return includeTrue ? this.createFinalArray(selected) : selected;
        },
        createFinalArray(data) {
            return data ? [...data] : [];
        },
        noKen(withConcent) {
            if (!withConcent) this.treatmentProcedure[this.treatmentProcedure.findIndex((treatment) => treatment.id == 7)].cant = null
        },
        async getDetails() {
            this.loading = true;
            axiosOV
                .dataForOMA(this.$route.params.id)
                .then(async ({ all, office_visit, paginates, rooms, membership, iv_serums }) => {
                    if (office_visit.visit_statuses_id == 5 || office_visit.visit_statuses_id == 6) return this.$router.go(-1);
                    const { check, message } = await this.omaProcedure(this.$route.params.id);
                    if (check != true) {
                        Swal.fire({
                            title: "Error!",
                            text: message || "Could not take this visit for OMA.",
                            icon: "error",
                            customClass: {
                                confirmButton: "btn btn-primary",
                            },
                            buttonsStyling: false,
                        });
                        this.$router.go(-1);
                        return;
                    }
                    const {
                        type_vital_sign,
                        review_of_system: CategoryReviewSystem,
                        category_lab: CategoryLaboratory,
                        treatments,
                        sonograms: CategoryDiagnosticImaging,
                    } = all;
                    this.membership = membership;
                    const isReducedType = membership && membership.memberships_parameters &&
                        Number(membership.memberships_parameters.membership_type) === 1;
                    this.applyMembership = isReducedType ? !!(membership && membership.id) : true;

                    this.signVitalsOptions = type_vital_sign;
                    this.vitalSign = this.signVitalsOptions.map((item) => {
                        return {
                            id: item.id,
                            value: null,
                        };
                    });

                    this.roomOptions = rooms.map((room) => {
                        return {
                            id: room,
                            name: room,
                        };
                    });

                    const {
                        appointments: {
                            patients,
                            facilities,
                            ajustment,
                            consult_prices,
                            campaign_cupon,
                            reason_visit,
                            id,
                            visit_date: appointmentVisitDate,
                            type_visits_id
                        },
                        room,
                        review_of_system,
                        type_vital_sign: VitalSignUser,
                        examination,
                        describe_abnormal,
                        describe_diagnoses,
                        diagnosis,
                        laboratories,
                        laboratories_pack,
                        diagnostic_imagings,
                        package: pack,
                        tests: testUser,
                        procedures: procedureUser,
                        treatments: treatmentUser,
                        signature,
                        authorization,
                    } = office_visit;
                    const rum = []
                    room != undefined || room != null ? rum.push(room) : ''
                    this.detailPatient = {
                        type_visits_id: this.normalizeTypeVisitId(type_visits_id) || type_visits_id,
                        appointmentsId: id,
                        reason_visit: reason_visit,
                        campaign_cupon: campaign_cupon,
                        gender: patients.gender,
                        name: patients.name,
                        lastName: patients.lastname,
                        phone: patients.phone,
                        dateBirth: patients.date_birth,
                        facility: facilities.name,
                        facilityId: facilities.id != null ? facilities.id : (facilities.facilities_id || null),
                        visitDate: appointmentVisitDate,
                        weightlossPatientId: this.resolveWeightlossPatientId(office_visit, patients),
                        room: rum
                    };
                    if (this.isPendingInjection) {
                        this.weightlossMode = 'consume'
                        await this.loadWeightlossBalances(this.$route.params.id)
                    } else {
                        this.weightlossMode = 'sell'
                        this.weightlossBalances = []
                    }
                    await this.hydrateWeightlossFromOfficeVisit(office_visit)

                    const { histories } = patients;
                    this.medicalHistory = {
                        ailments: histories.ailment.map((item) => item.id),
                        allergies: histories.allergies.map((item) => item.id),
                        medicationInformation: histories.medication_informations,
                        current_medications: histories.current_medications,
                        userId: histories.users_id,
                        historyId: histories.id,
                    };

                    VitalSignUser.forEach((elem, i) => {
                        this.vitalSign[i].value = elem.pivot.value;
                    });

                    const {
                        ailments,
                        allergies,
                        medication,
                        diagnoses,
                        tests,
                        procedure,
                        medication_patient,
                    } = paginates;

                    this.ailmentOptions.data = ailments.data;
                    this.allergiesOptions.data = allergies.data;
                    this.medicationsOptions.data = medication.data;
                    this.diagnosesOptions.data = diagnoses.data;
                    this.testOptions.data = tests.data;
                    this.procedureOptions.data = procedure.data;
                    this.medicationsPatientOptions.data = medication_patient.original.registro.data;

                    this.medicalHistoryConditional = true;

                    let laboratoriesObject = {};

                    this.reviewSystemSelected = this.createInicialCategories(
                        review_of_system,
                        "category"
                    );

                    this.reviewSystemLength.data = CategoryReviewSystem;

                    this.assessmentProcedure = {
                        examination,
                        describeAbnormal: describe_abnormal,
                        describeDiagnoses: describe_diagnoses,
                        diagnosis,
                    };

                    let laboratoriesUser = laboratories;

                    if (
                        laboratories.some((item) => item.pivot.promotion)
                    ) {
                        const { promitions, array } = this.clearPromotions(
                            laboratories,
                            CategoryLaboratory,
                            "laboratories"
                        );
                        laboratoriesUser = array;
                        this.laboratoryPromotion = promitions;
                    }

                    laboratoriesUser.forEach((x) => {
                        if (!laboratoriesObject.hasOwnProperty(x.categories[0].name)) {
                            laboratoriesObject[x.categories[0].name] = [];
                        }
                        laboratoriesObject[x.categories[0].name].push(x);
                    });
                    for (const laboratory of laboratories_pack) {
                        const id = laboratory.office_visitable_id;
                        this.procedurePacks.checkCategoryLaboratory[id] = true;
                        this.procedurePacks.laboratoriesPack.push({ id, ...laboratory });
                    }

                    this.laboratorySelected = laboratoriesObject;
                    const catLaboratories = CategoryLaboratory.map(
                        ({ laboratories, ...res }) => {
                            const laboratoriesM = laboratories.filter(
                                (laboratory) => laboratory.price != null
                            );
                            return {
                                laboratoriesM,
                                ...res,
                            };
                        }
                    );
                    this.laboratoryLength.data = catLaboratories;

                    this.interventionsProcedure = {
                        tests: testUser.map((item) => {
                            let id = item.office_visitable_id;
                            return {
                                id,
                                ...item,
                            };
                        }),
                        procedures: procedureUser.map((item) => {
                            let id = item.office_visitable_id;
                            return {
                                id,
                                ...item,
                            };
                        }),
                    };

                    this.treatmentOptions = this.checkPromotion(
                        treatments,
                        treatmentUser
                    );

                    this.treatmentProcedure = this.treatmentOptions.map((item) => {
                        return {
                            id: item.id,
                            cant: null,
                            price: item.price,
                            options: [],
                            is_iv_serum_marker: item.is_iv_serum_marker === true,
                            membership_discount_exempt: item.membership_discount_exempt === true,
                        };
                    });

                    this.treatmentProcedure.forEach((iterator, index) => {
                        treatmentUser.forEach((elem) => {
                            if (iterator.id === elem.office_visitable_id) {
                                this.treatmentProcedure[index].cant = elem.pivot.cant;
                            }
                        });
                    });

                    let diagnosticUser = diagnostic_imagings;
                    if (
                        diagnostic_imagings.some((item) => item.pivot.promotion)
                    ) {
                        const { promitions, array } = this.clearPromotions(
                            diagnostic_imagings,
                            CategoryDiagnosticImaging,
                            "diagnostic_imagings"
                        );
                        diagnosticUser = array;
                        this.diagnosticPromotion = promitions;
                    }
                    this.diagnosticSelected = this.createInicialCategories(
                        diagnosticUser,
                        "category_diagnostic_imagings"
                    );

                    const catImaging = CategoryDiagnosticImaging.map(
                        ({ diagnostic_imagings, ...res }) => {
                            const diagnosticM = diagnostic_imagings.filter(
                                (laboratory) => laboratory.price != null
                            );
                            return {
                                diagnosticM,
                                ...res,
                            };
                        }
                    );
                    this.diagnosticLength.data = catImaging;

                    this.costProcedure = {
                        signature,
                        adjusment: ajustment === null ? 0 : ajustment,
                        authorization,
                    };
                    this.consultationPrice = consult_prices;

                    this.loading = false;
                    this.$nextTick(() => this.initWizard());
                    this.initialIvSerums = Array.isArray(iv_serums) ? iv_serums : []
                    if (pack && !isIvTherapyPackage(pack)) {
                        pack.label = pack.name
                        this.package.all = [pack]
                        this.package.data = pack.id
                        this.$emit('getPackageData')
                    }
                })
                .catch((error) => {
                    console.error('[OmaProcedure getDetails]', error);
                    this.loading = false;
                    this.$router.go(-1);
                });

        },
        resolveWeightlossPatientId(officeVisit, patient) {
            const profile =
                patient?.weightloss_patient ||
                patient?.weightlossPatient ||
                patient?.weightloss ||
                officeVisit?.weightloss_patient ||
                officeVisit?.weightlossPatient ||
                officeVisit?.weightloss?.weightloss_patient
            if (Array.isArray(profile)) return profile[0]?.id || null
            return (
                profile?.id ||
                patient?.weightloss_patient_id ||
                officeVisit?.weightloss_patient_id ||
                null
            )
        },
        async omaProcedure(id) {
            const data = {
                office_visits_id: id,
            };
            const res = await axiosOV.assignToOma(data);
            if (!res) {
                return {
                    check: false,
                    message: "takeVisit returned no response (network/API error). Check console and Network tab.",
                };
            }
            const { status, message } = res;
            if (status === "OK") {
                return { check: true };
            }
            return {
                check: false,
                message: message || `takeVisit failed with status: ${status}`,
            };
        },
        createFinalCategories(arrayBackend, categories = false) {
            const finallyArrayCategories = [];
            for (const key in arrayBackend) {
                if (Object.hasOwnProperty.call(arrayBackend, key)) {
                    if (categories) {
                        finallyArrayCategories.push(
                            ...arrayBackend[key].map((item) => item.id)
                        );
                    } else {
                        finallyArrayCategories.push(...arrayBackend[key]);
                    }
                }
            }
            return finallyArrayCategories;
        },
        createFinalArray(arrayBackend) {
            const arrayNormal = [];
            for (const iterator of arrayBackend) {
                arrayNormal.push(iterator.id || iterator.historyble_id);
            }
            return arrayNormal;
        },
        createInicialCategories(arrayBackend, nameIterator) {
            const categoriesInicialTemporal = {};
            arrayBackend.forEach((x) => {
                if (!categoriesInicialTemporal.hasOwnProperty(x[nameIterator].name)) {
                    categoriesInicialTemporal[x[nameIterator].name] = [];
                }
                if (nameIterator === "category_diagnostic_imagings") {
                    let id = x.office_visitable_id;
                    categoriesInicialTemporal[x[nameIterator].name].push({ ...x, id });
                } else {
                    categoriesInicialTemporal[x[nameIterator].name].push(
                        x.assessmentable_id
                    );
                }
            });
            return categoriesInicialTemporal;
        },
        checkPromotion(treatmentsOptions, treatmentUser) {
            const treatmentFinal = treatmentsOptions.map((item) => {
                if (treatmentUser.filter((itemFilter) => itemFilter.office_visitable_id === item.id).length) {
                    return { ...item, promotion: true };
                } else {
                    return { ...item, promotion: false };
                }
            });
            return treatmentFinal;
        },
        totalAdjustment(value) {
            this.costProcedure.adjusment = value;
        },
        totalPrice(value) {
            if (value > 550) {
                // this.$refs.cost.trueOverrun()
            }
            this.totalPriceProcedure = value;
        },
        pricePackage(value) {
            this.totalPricePackage = value;
        },
        onIvChange({ serums, pricing, serumsTotal, addonsTotal, error, loading, invalid }) {
            this.ivSerums = serums || []
            this.ivPricing = pricing || null
            this.totalPriceIvSerums = serumsTotal
            this.totalPriceIvAddons = addonsTotal
            this.ivQuoteError = error || ''
            this.ivQuoteLoading = !!loading
            this.ivInvalidMessage = invalid || ''
        },
        validateIvSerums() {
            if (this.ivInvalidMessage) {
                this.$refs.toast.danger(this.ivInvalidMessage)
                return false
            }
            if (!this.ivSerums.length) return true
            if (this.ivQuoteLoading) {
                this.$refs.toast.warning('Wait for the IV price calculation to finish.')
                return false
            }
            if (this.ivQuoteError) {
                this.$refs.toast.danger(this.ivQuoteError)
                return false
            }
            if (!this.ivPricing) {
                this.$refs.toast.danger('A valid IV pricing quote is required.')
                return false
            }
            return true
        },
        initWizard() {
            this.wizardForm = new KTWizard("kt_wizard_v2", {
                startStep: 1,
                clickableSteps: true,
            });
            this.wizardForm.on("submit", function (wizardObj) {
                setTimeout(() => KTUtil.scrollTop(), 500);
            });
        },
        onApplyMembership(value) {
            this.applyMembership = value;
        },
        clearSignature() {
            this.$refs.signaturePad.clearSignature();
        },
        isSignature() {
            const { isEmpty } = this.$refs.signaturePad.saveSignature();
            return !isEmpty;
        },
        async uploadPhoto(file) {
            const formData = new FormData();
            formData.append("file", file);
            const { secure_url } = await axiosEC.createImage(formData);
            return secure_url;
        },
        validationFormPatient() {
            return new Promise((resolve, reject) => {
                this.$refs.patientRef.validate().then((success) => {
                    if (success) {
                        resolve(true);
                    } else {
                        reject();
                        wizardObj.stop();
                    }
                });
            });
        },
    },
};
</script>
